export const useValidateUtil = {
  /**
   * 去空格后非空验证
   */
  isEmptyTrim: source => {
    return !source || source.toString().trim() === ''
  },

  /**
   * 数组非空验证
   */
  isEmptyArray: source => {
    return !source || source.length === 0
  },

  /**
   * 密码验证
   */
  isPassword: password => {
    return password && /^(?![0-9]+$)(?![a-zA-Z]+$)[a-zA-Z0-9]{8,16}$/.test(password)
  },

  /**
   * 座机验证
   */
  isLandLine: landLine => {
    return landLine && /^0\d{2,3}-?\d{7,8}$/.test(landLine)
  },

  /**
   * 手机号验证
   */
  isNumber: number => {
    return number && /^[0-9]*$/.test(number)
  },

  /**
   * 手机号验证
   */
  isMobile: mobile => {
    return mobile && /^1(3\d{2}|4[14-9]\d|5([0-35689]\d|7[1-79])|66\d|7[2-35-8]\d|8\d{2}|9[13589]\d)\d{7}$/.test(mobile)
  },

  /**
   * 邮箱验证
   */
  isEmail: email => {
    /* eslint-disable */
    return email && /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(email)
  },

  /**
   * 身份证验证
   */
  isIdentity: identity => {
    return (
      identity &&
      /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(
        identity
      )
    )
  },

  /**
   * 银行卡验证
   */
  isBankCode: bankCode => {
    return bankCode && /^([1-9]{1})(\d{11}|\d{14}|\d{15}|\d{16}|\d{17}|\d{18})$/.test(bankCode)
  },

  /**
   * 金额验证
   */
  isMoney: money => {
    return money && /^(([1-9]\d*)|\d)(\.\d{1,2})?$/.test(money)
  },

  /**
   * 外部跳转验证
   */
  isExternal: path => {
    return path && /^(https?:|mailto:|tel:)/.test(path)
  },

  /**
   * 是否存在中文符号
   */
  isChineseSymbol: str => {
    return str && /[\u4e00-\u9fff]/.test(str)
  }
}
